import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { v as bvVar } from 'bv';
import { isInComponentsIframe } from 'bv-services';
import classNames from 'classnames';
import { partnerLogos, showLogo, showPartners } from 'footer-config';

import Ambassador from './ambassador';
import PartnerLogos from './partner_logos';

const {
  footerLinks,
  snippet,
  logos,
} = bvVar('footerSettings');

const ambassador = bvVar('ambassador');

const SiteFooter = ({ className, tagName: Tag }) => {
  const footerInfoRef = useRef(null);
  const linkTargetAttrs = isInComponentsIframe() ? { target: '_blank', 'data-react': true } : {};

  useEffect(() => {
    if (footerInfoRef && footerInfoRef.current) {
      [...footerInfoRef.current.getElementsByTagName('a')].forEach((link) => {
        Object.entries(linkTargetAttrs).forEach(([key, value]) => link.setAttribute(key, value));
      });
    }
  }, [footerInfoRef]);

  return (
    <Tag className={`site-footer${className ? ` ${className}` : ''}`}>
      {showLogo && <div className={classNames('bvs-site-logo_footer', className)} />}
      {ambassador && <Ambassador hasBackground={false} />}
      {showPartners && partnerLogos.length > 0 && <PartnerLogos />}
      <nav>
        <ul className="id-homepage_footer">
          <li className="id-homepage_footer_ts_and_cs">
            {footerLinks.map(({ url, title }) => (
              <a href={url} className="static-page" {...linkTargetAttrs}>{title}</a>
            ))}
          </li>
          <li
            className="id-homepage_footer_info"
            dangerouslySetInnerHTML={{ __html: snippet }}
            ref={footerInfoRef}
          />
          <li className="id-homepage_footer_logos">
            {logos.map(({ class: logoClassName, href, ...rest }) => (
              <a href={href} className={logoClassName} {...rest} {...linkTargetAttrs} />
            ))}
          </li>
        </ul>
      </nav>
    </Tag>
  );
};

SiteFooter.propTypes = {
  className: PropTypes.string,
  tagName: PropTypes.string,
  target: PropTypes.string,
};

SiteFooter.defaultProps = {
  className: '',
  tagName: 'footer',
  target: '_self',
};

export default SiteFooter;
